import { isNil } from "es-toolkit";
import { defineStore } from "pinia";
import { ref } from "vue";

export interface BreadcrumbItem {
    label: string;
    route?: string;
    fn?: () => void;
}

export function matchBackUrl(itemRoute: string) {
    const prevPath = window.history.state?.back;
    if (isNil(prevPath) || prevPath === "") {
        return false;
    }

    if (itemRoute === prevPath || itemRoute === "/") {
        return false;
    }

    return prevPath.startsWith(itemRoute + "/") || prevPath.startsWith(itemRoute + "?");
}

export const useBreadcrumbStore = defineStore("breadcrumb", () => {
    const crumbs = ref<BreadcrumbItem[]>([]);

    function setCrumbs(newCrumbs: BreadcrumbItem[]) {
        crumbs.value = newCrumbs;
    }

    function resetCrumbs() {
        crumbs.value = [];
    }

    return { crumbs, setCrumbs, resetCrumbs };
});
